/* istanbul ignore file */

import styled from 'styled-components'

export const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ChartArea = styled.div`
  width: 100%;
  height: 165px;
`

export const ValuesContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 90px;

  text-align: center;

  & > div {
    max-width: 115px;
  }
`

export const LabelContainer = styled.div`
  span {
    color: ${props => props.theme.colors.accent.hover};
    text-transform: lowercase;
  }
`
